export const SET_FUEL_COMPANIES_LOADING = 'SET_FUEL_COMPANIES_LOADING';
export const SET_FUEL_COMPANIES = 'SET_FUEL_COMPANIES';
export const SET_FUEL_CARDS_LOADING = 'SET_FUEL_CARDS_LOADING';
export const SET_FUEL_CARDS = 'SET_FUEL_CARDS';
export const ADD_FUEL_CARD = 'ADD_FUEL_CARD';
export const UPDATE_FUEL_CARD = 'UPDATE_FUEL_CARD';
export const SET_TOTAL_FUEL_COMPANIES_COUNT = 'SET_TOTAL_FUEL_COMPANIES_COUNT';
export const SET_FUEL_CARDS_PAGINATION_LOADING = 'SET_FUEL_CARDS_PAGINATION_LOADING';
